//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//style
import './ChangeValues.scss';

//api
import { api } from '../../../functions/api';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, Chip, Button, CircularProgress } from '@material-ui/core';

//custom components
import CustomButton from '../../../components/basic/CustomButton';
import CustomInput from '../../../components/basic/input';

//other libraries
import uuid from 'uuid4';
import Icon from '@mdi/react';
import { mdiClose, mdiPencil, mdiPlus } from '@mdi/js';
import { create } from 'domain';

const selected = [
    {id: 1, name: "Novinka", color: "#2c59bc"},
    {id: 2, name: "Akcia", color: "#c09229"},
    {id: 3, name: "Do vypredania zásob", color: "#c8582a"},
    {id: 24, name: "Posledné kusy", color: "#047800"},
    {id: 21, name: "1Novinka", color: "#2c59bc"},
    {id: 25, name: "4Posledné kusy", color: "#047800"},
    {id: 23, name: "3Do vypredania zásob", color: "#c8582a"},
    {id: 22, name: "2Akcia", color: "#c09229"},
]

@inject('translate')
@inject('internal')
@observer
export default class ChangeValues extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            selected: selected,
            // selected: [],
            loading: true,
        }
    }

    isAddedNewValue = false

    componentDidMount() {
        let parameter_id = this.props.id
        this.loadParamValues()
    }

    loadParamValues = async () => {
        let parameter_id = this.props.id
        let load_data = await api({
            method: 'get',
            url: `lists/parameters/${parameter_id}/items`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.setState({
                loading: false,
                selected: load_data.data.data
            })
        }
    }

    handleDeleteValue = (item_id) => {
        const { user } = toJS(this.props.internal)
        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameter_items && user.data.permissions.lists_parameter_items.destroy) {
            let tmpSelected = this.state.selected;
            tmpSelected = tmpSelected.filter(param => param.id !== item_id);
            this.setState({selected: tmpSelected});
            this.deleteItem(item_id);
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    deleteItem = async(item_id) => {
        let parameter_id = this.props.id

        ///lists/parameters/:id/items/:itemId
        let delete_data = await api({
            method: 'delete',
            url: `lists/parameters/${parameter_id}/items/${item_id}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            // this.setState({selected: delete_data.data.data})
            this.loadParamValues()
            this.isAddedNewValue = true
        }
    }

    handleAddValue = () => {
        const { user } = toJS(this.props.internal)
        
        if(this.editItemObj !== null) {
            if(user && user.data && user.data.permissions && user.data.permissions.lists_parameter_items && user.data.permissions.lists_parameter_items.update) {
                let selected = this.state.selected;
                let idForEdit = selected.findIndex(data => data.id === this.editItemObj.id);
                selected[idForEdit].name = this.value_name.state.value;
                this.setState({selected: selected});
                this.editItem()
                this.value_name.setValue('');
            }
            else {
                this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
            }
        }
        else {
            if(user && user.data && user.data.permissions && user.data.permissions.lists_parameter_items && user.data.permissions.lists_parameter_items.store) {
                let value_name = this.value_name.state.value;
                let tmpSelected = this.state.selected
                tmpSelected.push({id: uuid(), name: value_name, color: "c8383a"});
                this.setState({selected: tmpSelected});
                this.value_name.setValue('');
                this.addItem(value_name)
            }
            else {
                this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
            }
        }
    }

    editItem = async() => {
        let parameter_id = this.props.id;
        let item_id = this.editItemObj.id;

        let update_data = await api({
            method: 'patch',
            url: `lists/parameters/${parameter_id}/items/${item_id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                name: this.value_name.state.value,
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.setState({selected: update_data.data.data})
            this.loadParamValues()
        }

        this.editItemObj = null;
    }

    addItem = async(value_name) => {
        let parameter_id = this.props.id
        let create_data = await api({
            method: 'post',
            url: `lists/parameters/${parameter_id}/items`,
            authorization: this.props.internal.user.access_token,
            params: {
                name: value_name
            }
        })

        if(create_data.success === false && create_data.status === 201) {
            this.props.internal.setSnackbar(create_data.data.message, true)
            // this.setState({selected: create_data.data.data})
            this.loadParamValues()
            this.isAddedNewValue = true
        }
    }
    
    editItemObj = null;
    handleEditValue = (item) => {
        const { user } = toJS(this.props.internal)
        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameter_items && user.data.permissions.lists_parameter_items.update) {
            this.value_name.setValue(item.name);
            this.editItemObj = item;
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                //reload hlavnej stranky
                onClose={() => this.props.onClose(this.isAddedNewValue)}
                // onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                classes={{
                    paper: "eidtParamValues"
                }}
            >
                <DialogTitle id="form-dialog-title" className={'param-value-title'}>
                    {this.props.title}
                    {/* <span onClick={this.props.onClose}>
                        <Icon size={1} path={mdiClose} className={'parameter-value-close'} />
                    </span> */}
                </DialogTitle>
                {this.state.loading ?
                    <DialogContent>
                        <CircularProgress className={'circular-progress'}/>
                    </DialogContent>
                    :
                <DialogContent>
                    
                    <div className={'parameter-values'} >
                        <p className={'list-values'}>{this.props.translate.i18n.MODULES.PARAMETERS.LIST_PARAM_VALUES}:</p>
                        {this.state.selected.length ? this.state.selected.map(value => (
                            <Chip
                                icon={<Icon path={mdiPencil} size={.75} className={'edit-value'}/>}
                                onClick={() => this.handleEditValue(value)}
                                key={value.id}
                                label={value.name}
                                onDelete={() => this.handleDeleteValue(value.id)}
                                className={'chip-value'}
                            />
                        ))
                        :
                        <span>{this.props.translate.i18n.GLOBAL.ALERTS.NO_FOUND_DATA_FOR_TABE}</span>
                        }
                    </div>
                    <div className={'newValue'}>
                        <CustomInput
                            ref={ref => this.value_name = ref}
                            text={this.props.translate.i18n.MODULES.PARAMETERS.VALUE_NAME}
                            value=""
                            id={'value_name'}
                            className={"w-100"}
                            // required
                            pressedButton
                            onPressButton={this.handleAddValue}
                            
                        />
                        <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.handleAddValue}
                            mystyle={'btn-transparent-bg'}
                            // mystyle = {'addValueBtn'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            justText
                            disabled={this.state.loading}
                        >
                        </CustomButton>
                    </div>

                </DialogContent>
                }
                <DialogActions>
                    {/* <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button> */}
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        //reload hlavnej stranky
                        onClick={() => this.props.onClose(this.isAddedNewValue)}
                        // onClick={this.props.onClose}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.CONTINUE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/parameters/ChangeValues/ChangeValues.js